import NewsletterForm from '@/components/NewsletterForm';
import { ContactCopy } from './HomePage';

export default function ContactPage() {
  return (
    <main>
      <section className="section contact-section">
        <h2 className="section-title">Contact</h2>
        <ContactCopy />
      </section>
      <NewsletterForm />
    </main>
  );
}
